import React, { Component } from 'react'
import { Button, Row, Form, Input } from 'antd'
import {Link} from 'dva/router'
import config from '../../utils/config'

const FormItem = Form.Item

class RecoveryPassword extends Component {
    
    handleSubmit(e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }
            this.props.onOk(values)
        })
    }

    render() {
        const {getFieldDecorator} = this.props.form;

        return (
            <div className={"login-box-body portlet-body"}>
                <div className={"login-logo"}>
                    <img src={config.logoSrc} alt={config.logoText}/>
                </div>

                <p className={'text-center padding20'}>Ingrese su correo electrónico</p>

                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <FormItem hasFeedback>
                        {getFieldDecorator('email', {
                            rules: [{
                                type: 'email',
                                required: true,
                                message: 'Por favor, ingrese un correo electrónico'
                            }]
                        })(<Input size='large' type='email' onPressEnter={this.handleSubmit.bind(this)} placeholder='Correo electrónico' />)}
                    </FormItem>
                    
                    <Row className={'text-center'}>
                        <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.buttonLoading} className={'btn btn-primary btn-flat'}>
                            Recuperar contraseña
                        </Button>
                    </Row>

                    <p className={'text-center paddingTop20'}><Link onClick={this.props.changeLogin}>Iniciar sessión</Link></p>
                </Form>
            </div>
        );
    }
};

export default Form.create()(RecoveryPassword)


// WEBPACK FOOTER //
// ./src/components/authentication/recoveryPassword.js